import { Dto, DtoWithId } from "@mango/core";
import { Pakbon } from "./pakbon";
import { Relatie } from "./relatie";
import { Taal } from "./taal";
import { User } from "@mango/authorization";


@Dto({fullName: "CIJBorculo.Logic.Factuur"})
export class Factuur extends DtoWithId {
	oldID: number;
	relatie: Relatie;
	naam1: string;
	naam2: string;
	adres1: string;
	postcode: string;
	plaats: string;
	land: string;
	eMail: string;
	omschrijving1: string;
	omschrijving2: string;
	factuurDatum: Date;
	opmerking: string;
	totaalbedrag: number;
	factuurperiode: string;
	isProForma: boolean;
	pakbon:Pakbon;
	verzendkosten: number;
	isCopy: boolean;
	mailDatum: Date;
	prijsMetKorting: number;
	totaalArtikelen: number;
	totaalKalibratie: number;
	totaalKalibratieMetKorting: number;
	goedgekeurdOp: Date;
	goedgekeurdDoor: User;
	naarExactOp: Date;
	naarExactDoor: User;
	foutmeldingExact: string;

}